import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ProductPage from "@/pages/ProductPage";
import AdminLeads from "@/pages/AdminLeads";
import Reschedule from "@/pages/Reschedule";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ProductPage />} />
          <Route path="/admin/leads" element={<AdminLeads />} />
          <Route path="/reschedule/:leadId" element={<Reschedule />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default App;
